import {
  CloseIcon,
  FlexBox,
  JoonUIColor,
  SPACING,
  Typography,
} from "@joonapp/web-shared"

import { useDeleteInvitationModalStore } from "./DeleteInvitationModal"
import ButtonSmall from "../../../components/buttons/ButtonSmall"
import { InvitationGroup } from "../../../types"

type Props = {
  invitationGroup: InvitationGroup
}

const DeleteInviteButton = ({ invitationGroup }: Props) => {
  const { onOpen: onOpenDeleteInvitationModal } =
    useDeleteInvitationModalStore()

  const onClickDelete = () => {
    onOpenDeleteInvitationModal(invitationGroup[0].id)
  }

  return (
    <ButtonSmall onClick={onClickDelete}>
      <FlexBox direction="row" gap={SPACING.space2} wrap={false} align="center">
        <CloseIcon color={JoonUIColor.semantic.destructive} size={16} />
        <Typography variant="bodySmall">Delete</Typography>
      </FlexBox>
    </ButtonSmall>
  )
}

export default DeleteInviteButton
